import { Link, NavLink, useNavigate } from "react-router-dom";
import { Search, Map, Route, Heart, Store, LogOut, UserRound } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useCrawl } from "@/context/CrawlContext";

const NAV = [
  { to: "/", label: "Find", icon: Search, id: "nav-find" },
  { to: "/map", label: "Map", icon: Map, id: "nav-map" },
  { to: "/crawl", label: "Bar Crawl", icon: Route, id: "nav-crawl" },
  { to: "/saved", label: "Saved", icon: Heart, id: "nav-saved" },
  { to: "/submit", label: "Own a Bar?", icon: Store, id: "nav-submit" },
];

function NavItem({ item, count }) {
  const Icon = item.icon;
  return (
    <NavLink
      to={item.to}
      end
      data-testid={item.id}
      className={({ isActive }) =>
        `flex shrink-0 items-center gap-1.5 rounded-full px-3.5 py-2 text-sm font-semibold transition-colors ${
          isActive ? "bg-[#fde68a] text-zinc-950" : "text-zinc-300 hover:bg-zinc-800/70 hover:text-white"
        }`
      }
    >
      <Icon size={15} />
      {item.label}
      {count > 0 && <span className="ml-0.5 rounded-full bg-zinc-950 px-1.5 text-[10px] text-[#fde68a]">{count}</span>}
    </NavLink>
  );
}

function UserControl() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  if (!user) {
    return (
      <Link to="/login" data-testid="header-login-link" className="flex items-center gap-1.5 rounded-full border border-zinc-700 px-3.5 py-2 text-sm font-semibold text-zinc-200 hover:border-[#fde68a] hover:text-[#fde68a]">
        <UserRound size={15} /> Log in
      </Link>
    );
  }
  return (
    <button
      data-testid="header-logout-button"
      onClick={async () => { await logout(); nav("/"); }}
      className="flex items-center gap-1.5 rounded-full border border-zinc-700 px-3.5 py-2 text-sm font-semibold text-zinc-300 hover:text-white"
    >
      <LogOut size={15} /> <span className="hidden sm:inline">{user.name?.split(" ")[0] || "Account"} ·</span> Log out
    </button>
  );
}

export function Header() {
  const { stops } = useCrawl();
  return (
    <header className="sticky top-0 z-40 border-b border-zinc-800 bg-zinc-950/90 backdrop-blur-md">
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 pt-4 sm:px-6">
        <Link to="/" data-testid="header-logo" className="group flex items-center gap-3">
          <img src="/logo192.png" alt="My Happy Hour logo" data-testid="header-logo-icon" className="h-11 w-11 rounded-2xl border border-[#fde68a]/40 transition-transform group-hover:-rotate-6 sm:h-14 sm:w-14" />
          <span className="font-heading logo-glow text-4xl leading-none sm:text-5xl lg:text-6xl">My Happy Hour</span>
        </Link>
        <UserControl />
      </div>
      <nav className="no-scrollbar mx-auto flex max-w-7xl gap-1.5 overflow-x-auto px-4 py-3 sm:px-6">
        {NAV.map((n) => <NavItem key={n.to} item={n} count={n.to === "/crawl" ? stops.length : 0} />)}
      </nav>
    </header>
  );
}
